<template>
  <div class="container mt-4" dir="rtl">
    
    <!-- 1. الفلاتر -->
    <div class="card no-print mb-4 shadow-sm border-top-primary">
      <div class="card-header bg-white">
        <h5 class="fw-bold text-primary mb-0"><i class="fas fa-envelope-open-text ms-2"></i> طباعة ملصق إحصاء المدرسة (للظرف)</h5>
      </div>
      <div class="card-body">
        <div class="row g-3 align-items-end">
            <div class="col-md-2">
                <label class="fw-bold small">الفصل الدراسي</label>
                <select v-model="form.term_id" class="form-select">
                    <option value="1">الأول</option>
                    <option value="2">الثاني</option>
                </select>
            </div>
            <div class="col-md-3">
                <label class="fw-bold small">الإدارة</label>
                <select v-model="form.admin_id" @change="fetchSchools" class="form-select">
                    <option v-for="adm in administrations" :key="adm.id" :value="adm.id">{{ adm.dep_name }}</option>
                </select>
            </div>
            <div class="col-md-3">
                <div class="form-check mt-3">
                    <input class="form-check-input" type="radio" value="all" v-model="form.scope">
                    <label class="form-check-label fw-bold">طباعة كل مدارس الإدارة</label>
                </div>
                <div class="form-check">
                    <input class="form-check-input" type="radio" value="one" v-model="form.scope">
                    <label class="form-check-label fw-bold">مدرسة محددة</label>
                </div>
            </div>
            <div class="col-md-4" v-if="form.scope === 'one'">
                <label class="fw-bold small">اختر المدرسة</label>
                <select v-model="form.school_id" class="form-select">
                    <option v-for="s in schoolsList" :key="s.id" :value="s.id">{{ s.school_name }}</option>
                </select>
            </div>
        </div>
        <div class="text-center mt-3 border-top pt-3">
            <button @click="fetchData" class="btn btn-primary px-5 fw-bold" :disabled="loading">
                <span v-if="loading" class="spinner-border spinner-border-sm"></span> عرض
            </button>
            <button @click="printPage" class="btn btn-dark px-5 fw-bold ms-2" :disabled="reports.length === 0">طباعة</button>
        </div>
      </div>
    </div>

    <!-- 2. منطقة الطباعة -->
    <div id="printMe" v-if="reports.length > 0" class="print-area">
      
      <div v-for="(school, index) in reports" :key="index" class="envelope-wrapper" style="page-break-after: always;">
          
          <div class="envelope-box">
            
            <div class="text-center mb-2 border-bottom border-2 border-dark pb-2">
                <h4 class="fw-bold text-decoration-underline">بيان إحصائي لأرقام جلوس المدرسة</h4>
                <h6 class="fw-bold">الشهادة الإعدادية - {{ termName }} 2026</h6>
            </div>

            <div class="school-title-box text-center my-3">
                <h2 class="fw-bold m-0 p-2 bg-dark text-white d-inline-block rounded px-4 border border-dark print-bg-black">
                    {{ school.school_name }}
                </h2>
                <div class="mt-1 fw-bold fs-5">
                    كود: <span class="font-monospace border border-dark px-2">{{ school.code_school }}</span> | 
                    إدارة: {{ school.admin_name }}
                </div>
            </div>

            <!-- الجدول الرئيسي المعدل -->
           <table class="table table-bordered border-dark text-center align-middle mb-4 custom-table shadow-sm">
    <thead>
        <!-- الصف الأول: العناوين الرئيسية -->
        <tr class="bg-dark text-white print-bg-black">
            <th rowspan="2" style="width: 20%" class="fs-5 align-middle border-end border-light">البيان</th>
            <th colspan="2" style="width: 40%" class="fs-5 border-bottom border-light">نطاق أرقام الجلوس</th>
            <th rowspan="2" style="width: 15%" class="fs-5 align-middle border-start border-light">العدد</th>
            <th rowspan="2" style="width: 25%" class="fs-5 align-middle">ملاحظات (تلاحيق)</th>
        </tr>
        <!-- الصف الثاني: من / إلى -->
        <tr class="bg-secondary text-white print-grey">
            <th class="py-1">من</th>
            <th class="py-1 border-start border-light">إلى</th>
        </tr>
    </thead>
    <tbody>
        <!-- صف النظامي -->
        <tr>
            <td class="fw-bold fs-5 bg-light text-start ps-3">طلاب نظامي</td>
            <td class="fw-bold fs-3 font-monospace text-primary">{{ school.stats.reg_min || '-' }}</td>
            <td class="fw-bold fs-3 font-monospace text-primary border-start">{{ school.stats.reg_max || '-' }}</td>
            <td class="fw-bold fs-3 bg-light-subtle">{{ school.stats.count_regular }}</td>
            <td class="small fw-bold text-danger">{{ school.stats.tk_reg_seats || '' }}</td>
        </tr>
        
        <!-- صف المنازل -->
        <tr>
            <td class="fw-bold fs-5 bg-light text-start ps-3">طلاب منازل</td>
            <td class="fw-bold fs-3 font-monospace text-dark">{{ school.stats.home_min || '-' }}</td>
            <td class="fw-bold fs-3 font-monospace text-dark border-start">{{ school.stats.home_max || '-' }}</td>
            <td class="fw-bold fs-3 bg-light-subtle">{{ school.stats.count_homes }}</td>
            <td class="small fw-bold text-danger">{{ school.stats.tk_home_seats || '' }}</td>
        </tr>
        
        <!-- صف الإجمالي (المميز) -->
        <tr class="total-row border-top-3">
            <td class="fw-bold fs-4 bg-dark text-white print-bg-black text-start ps-3">الإجمالي العام</td>
            <td colspan="2" class="bg-secondary print-grey"></td> <!-- فراغ جمالي -->
            <td class="fw-bold fs-1 text-dark border-start border-end border-3 border-dark">{{ school.stats.total }}</td>
            <td class="bg-light"></td>
        </tr>
    </tbody>
</table>

            <!-- الفئات الأخرى -->
            <div class="row g-0 border border-dark text-center mb-3">
                <div class="col-3 border-end border-dark p-1 bg-light fw-bold">مسلم</div>
                <div class="col-3 border-end border-dark p-1 fw-bold fs-5">{{ school.stats.muslim }}</div>
                <div class="col-3 border-end border-dark p-1 bg-light fw-bold">مسيحي</div>
                <div class="col-3 p-1 fw-bold fs-5">{{ school.stats.christian }}</div>
            </div>
            
            <div class="row g-0 border border-dark text-center mb-3 border-top-0">
                <div class="col-3 border-end border-dark p-1 bg-light fw-bold">دمج</div>
                <div class="col-3 border-end border-dark p-1 fw-bold fs-5">{{ school.stats.damg }}</div>
                <div class="col-3 border-end border-dark p-1 bg-light fw-bold">وافد</div>
                <div class="col-3 p-1 fw-bold fs-5">{{ school.stats.wafed }}</div>
            </div>

            <div class="footer-box text-center mt-4">
                <div class="row">
                    <div class="col-6"><h6 class="fw-bold text-decoration-underline">شئون الطلبة</h6><p class="mt-3">..................</p></div>
                    <div class="col-6"><h6 class="fw-bold text-decoration-underline">مدير المدرسة</h6><p class="mt-3">..................</p></div>
                </div>
            </div>

          </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api/axios';

export default {
  data() {
    return {
      loading: false,
      administrations: [],
      schoolsList: [],
      reports: [],
      form: { term_id: 1, admin_id: '', scope: 'one', school_id: '' }
    };
  },
  computed: {
      termName() { return this.form.term_id == 1 ? 'الفصل الدراسي الأول' : 'الفصل الدراسي الثاني'; }
  },
  mounted() {
      this.fetchAdmins();
  },
  methods: {
    async fetchAdmins() {
        const res = await api.get('getadmins');
        this.administrations = res.data;
    },
    async fetchSchools() {
        if(!this.form.admin_id) return;
        const res = await api.get(`/admin/schools?admin_id=${this.form.admin_id}`);
        this.schoolsList = res.data;
    },
    async fetchData() {
        this.loading = true;
        try {
            const res = await api.post('/admin/reports/school-envelope', this.form);
            this.reports = res.data;
        } catch(e) { alert("خطأ"); } 
        finally { this.loading = false; }
    },
    printPage() { this.$htmlToPaper("printMe"); }
  }
};
</script>

<style scoped>
.border-top-primary { border-top: 4px solid #0d6efd; }
.font-monospace { font-family: 'Courier New', monospace; }

@media print {
    @page { size: A5 landscape; margin: 5mm; }
    .no-print { display: none !important; }
    #printMe { visibility: visible; position: absolute; left: 0; top: 0; width: 100%; }
    .envelope-wrapper { page-break-after: always; display: flex; justify-content: center; align-items: center; height: 95vh; }
    .envelope-box { width: 100%; border: 3px solid #000; padding: 15px; border-radius: 10px; }
    .custom-table th, .custom-table td { border: 2px solid #000 !important; font-size: 14pt; }
    .print-bg-black { background-color: #000 !important; color: #fff !important; -webkit-print-color-adjust: exact; }
    .print-grey { background-color: #999 !important; -webkit-print-color-adjust: exact; }
    .bg-light { background-color: #eee !important; -webkit-print-color-adjust: exact; }
}

/* خط الأرقام المميز */
.font-monospace { font-family: 'Courier New', Courier, monospace; letter-spacing: 1px; }

/* حدود الجدول */
.custom-table {
    border: 2px solid #000;
}
.border-top-3 {
    border-top: 3px double #000 !important;
}

/* تنسيقات الطباعة */
@media print {
    /* ... (نفس إعدادات الصفحة السابقة) ... */

    /* تحسين الجدول في الطباعة */
    .custom-table th, .custom-table td {
        border: 1px solid #000 !important;
    }
    
    /* الألوان في الطباعة */
    .print-bg-black {
        background-color: #000 !important;
        color: #fff !important;
        -webkit-print-color-adjust: exact;
    }
    .print-grey {
        background-color: #999 !important;
        color: #000 !important;
        -webkit-print-color-adjust: exact;
    }
    .bg-light {
        background-color: #f0f0f0 !important;
        -webkit-print-color-adjust: exact;
    }
    
    /* تكبير خط الأرقام ليكون واضحاً جداً */
    .fs-3 { font-size: 16pt !important; }
    .fs-1 { font-size: 24pt !important; }
}
</style>